import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { CompanySettingService } from './company-setting.service';

@Injectable({
  providedIn: 'root'
})
export class CommonService {
  private BaseURL = '';
  private baseURLGenric = '';
  private CountryListURL = 'api/CountryDataList';
  private CityListURL = 'api/CityList';
  RecommendedInfoURL = 'api/RecommendedInfo';
  private header = new HttpHeaders({
    'Accept': 'application/json',
    'Content-Type': 'application/json; charset=utf-8',
    'Access-Control-Allow-Origin': '*',
    'Access-Control-Allow-Methods': 'GET,POST,OPTIONS,DELETE,PUT'
  });
  constructor(private _http: HttpClient) {
    this.BaseURL = environment.UtilityBaseURL;
    this.baseURLGenric = environment.GenericBaseURL;
   }
  GetCountryList() {
    return this._http.get(this.BaseURL + this.CountryListURL, { headers: this.header });
  }
  GetCityList(countryCode: any, cityname: any) {
    return this._http.get(this.BaseURL + this.CityListURL + '?countryCode=' + countryCode + '&&cityname=' + cityname, { headers: this.header });
  }
  GetRecommendedInfo() {
    return this._http.get(this.BaseURL + this.RecommendedInfoURL + "?CompanyCode="+CompanySettingService.CompanyCode+"&PageName=HOME&ValueType=PC,PH,PR");
  }
  //SubscribeNewsLetter
  SubscribeNewsLetter(request: any) {
    return this._http.post(this.baseURLGenric + "api/User/SubscribeNewsLetter", request, { headers: this.header });
  }
  //UserContactUs
  UserContactUs(request: any) {
    return this._http.post(this.baseURLGenric + "api/User/ContactUs", request, { headers: this.header });
  }
  //here change ClientServices
  SendSearchType (data: any) {
    return this._http.post(this.baseURLGenric  + "api/User/ClientServices", data);
  }
  //  here change AgencyList
  SendAgencyList (data: any) {
    return this._http.post(this.baseURLGenric  + "api/User/AgencyList", data);
  }
  // AgentLedger
  AgentLedger (data: any) {
    return this._http.post(this.baseURLGenric  + "api/Report/AgentLedger", data);
  }
  //FotgotPassword
  ForgotPass (data: any) {
    return this._http.post(this.baseURLGenric  + "api/User/ForgotPassword", data);
  }
}
